import AppConstants from 'constants/AppConstants';

export function setQuickActionsAvailable(params: { quickActionsAvailable: boolean }) {
  return {
    type: AppConstants.RESERVATIONS_SET_QUICKACTIONS_AVAILABLE,
    payload: params.quickActionsAvailable,
  };
}

export function setMobileQuickActionsAvailable(params: { quickActionsAvailable: boolean }) {
  return {
    type: AppConstants.RESERVATIONS_SET_MOBILE_QUICKACTIONS_AVAILABLE,
    payload: params.quickActionsAvailable,
  };
}

export function setShowActionsModal(params: { showActionsModal: boolean }): BaseTockAction {
  return {
    type: AppConstants.RESERVATIONS_SET_SHOW_ACTIONS_MODAL,
    payload: params.showActionsModal,
  };
}
